require('./bootstrap');
require('livewire-sortable')

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();